import { KeyValue } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function KeyValueDemo() {
  return (
    <Section
      id="key-value"
      title="KeyValue"
      description="Definition / spec list of label -> value pairs. Renderer for the K2 `key_value` block - props are the streamed `{ title?, pairs: [{label, value, href?, copyable?}], columns? }`."
    >
      <VariantBlock label="Single column">
        <div className="w-80">
          <KeyValue
            title="Deployment"
            pairs={[
              { label: "Environment", value: "staging" },
              { label: "Region", value: "us-east-1" },
              { label: "Commit", value: "a1b2c3d", copyable: true },
              { label: "Dashboard", value: "Open in console", href: "https://example.com/console" },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Two columns">
        <div className="w-[32rem]">
          <KeyValue
            title="Model run"
            columns={2}
            pairs={[
              { label: "Model", value: "claude-opus" },
              { label: "Tokens in", value: 1843 },
              { label: "Tokens out", value: 920 },
              { label: "Latency", value: "2.1s" },
              { label: "Cost", value: "$0.04" },
              { label: "Run id", value: "run_9f2", copyable: true },
            ]}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
